import { StatusBanner } from "@/components/StatusBanner";
import { CardLinkFields } from "@/features/cards/components/CardLinkFields";
import { TemplatePicker } from "@/features/cards/components/TemplatePicker";
import { CardRenderer } from "@/features/cards/templates/cardBackgrounds";

const Panel = ({ title, children }) => (
  <section className="rounded-lg border border-border bg-card p-5 sm:p-6">
    <h2 className="mb-5 font-serif text-xl tracking-tight">{title}</h2>
    {children}
  </section>
);

export const isCardEditorReady = (editor) => editor.load.status === "ready" && Boolean(editor.draft);

export function CardLoadState({ editor }) {
  if (editor.load.status === "error") {
    return (
      <div className="space-y-4 py-10">
        <StatusBanner testId="card-load-error">{editor.load.error}</StatusBanner>
        <button type="button" onClick={editor.reload} data-testid="card-retry-button" className="mw-btn mw-btn-ghost">Try again</button>
      </div>
    );
  }
  return <div data-testid="card-editor-loading" className="flex items-center gap-3 py-20"><span className="mw-spinner" /><span className="mw-eyebrow">Loading your card</span></div>;
}

export function CardEditor({ editor, footer }) {
  const { draft, identity } = editor;
  return (
    <div data-testid="card-editor" className="grid grid-cols-1 gap-8 lg:grid-cols-[320px_1fr]">
      <div className="min-w-0 space-y-6">
        <Panel title="Card & link"><CardLinkFields editor={editor} /></Panel>
        <Panel title="Background">
          <TemplatePicker value={draft.template_id} identity={identity} onChange={editor.setTemplate} />
        </Panel>
        {footer}
      </div>
      <div className="min-w-0 lg:sticky lg:top-8 lg:self-start">
        <p className="mw-eyebrow mb-4">Live preview</p>
        <div data-testid="card-preview" className="mx-auto w-full max-w-3xl drop-shadow-[0_24px_40px_rgba(0,0,0,0.12)]">
          <CardRenderer templateId={draft.template_id} identity={identity} idPrefix="card" />
        </div>
        <p className="mt-4 text-xs text-muted-foreground">
          Your card shows only the details you've added. The QR code opens your professional profile link.
        </p>
      </div>
    </div>
  );
}
